import { render, staticRenderFns } from "./ModelMainwh.vue?vue&type=template&id=69067be2&scoped=true"
import script from "./ModelMainwh.vue?vue&type=script&lang=js"
export * from "./ModelMainwh.vue?vue&type=script&lang=js"
import style0 from "./ModelMainwh.vue?vue&type=style&index=0&id=69067be2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69067be2",
  null
  
)

export default component.exports